import { render, staticRenderFns } from "./BpTotalLiabilitiesNumberDisplayer.vue?vue&type=template&id=a7ba5de2"
import script from "./BpTotalLiabilitiesNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpTotalLiabilitiesNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports